import { render, staticRenderFns } from "./edit_group_model.vue?vue&type=template&id=2bf949eb&scoped=true&"
import script from "./edit_group_model.vue?vue&type=script&lang=js&"
export * from "./edit_group_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf949eb",
  null
  
)

export default component.exports